import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, TextField, Button, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { createContact } from '../api/contacts';

interface AddContactModalProps {
  open: boolean;
  onClose: () => void;
  onContactCreated: () => void;
}

function AddContactModal({ open, onClose, onContactCreated }: AddContactModalProps): React.JSX.Element {
  const [form, setForm] = useState({
    name: '',
    age: '',
    parent_name: '',
    parent_phone: '',
    parent_email: '',
    notes: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createContact({ ...form, age: Number(form.age) });
      setForm({ name: '', age: '', parent_name: '', parent_phone: '', parent_email: '', notes: '' });
      onContactCreated();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        הוסף איש קשר
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="שם השחיין" value={form.name} onChange={handleChange('name')} required fullWidth />
          <TextField label="גיל" type="number" value={form.age} onChange={handleChange('age')} required fullWidth />
          <TextField label="שם ההורה" value={form.parent_name} onChange={handleChange('parent_name')} fullWidth />
          <TextField label="טלפון הורה" value={form.parent_phone} onChange={handleChange('parent_phone')} fullWidth />
          <TextField label="אימייל הורה" value={form.parent_email} onChange={handleChange('parent_email')} fullWidth />
          <TextField label="הערות" value={form.notes} onChange={handleChange('notes')} fullWidth multiline minRows={3} maxRows={8} />
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : 'הוסף איש קשר'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AddContactModal; 